import { IPartyNumberMap } from '../models/TypeHelper'
import { normalizePolls, randomizePolls } from '../utils/StatsUtils'
import UniformSwingModel from './UniformSwingModel'

class RandomUniformSwingModel {
  public static differences(
    oldPolls: IPartyNumberMap,
    newPolls: IPartyNumberMap,
    marginOfError: number = 0.03
  ): IPartyNumberMap {
    // First, we randomize support in the newPolls according to the MOE
    const randomizedPolls = randomizePolls(newPolls, marginOfError)

    // Now, normalize the randomized polls so they add up to 1
    const normalizedPolls = normalizePolls(randomizedPolls)

    return UniformSwingModel.differences(oldPolls, normalizedPolls)
  }
}

export default RandomUniformSwingModel
